import { render, staticRenderFns } from "./ArgesTarjetasEditarFoto.vue?vue&type=template&id=f43cbb4c&scoped=true&"
import script from "./ArgesTarjetasEditarFoto.vue?vue&type=script&lang=ts&"
export * from "./ArgesTarjetasEditarFoto.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesTarjetasEditarFoto.vue?vue&type=style&index=0&id=f43cbb4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43cbb4c",
  null
  
)

export default component.exports